import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';
import { TrashIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

export interface CommentActionsDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
  isDeleting?: boolean;
}

export function CommentActionsDrawer({
  open,
  onOpenChange,
  onDelete,
  isDeleting = false,
}: CommentActionsDrawerProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <div className="w-full">
          <DrawerHeader>
            <DrawerTitle>Comment Actions</DrawerTitle>
            <DrawerDescription className="sr-only">
              Actions for this comment.
            </DrawerDescription>
          </DrawerHeader>
          <div className="flex flex-col gap-2 pb-6">
            <CommentActionButton
              label="Delete"
              className="border border-red-400 text-red-400"
              icon={
                <TrashIcon
                  size={24}
                  weight="regular"
                  className="text-red-400"
                />
              }
              onClick={onDelete}
              disabled={isDeleting}
            />
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}

interface CommentActionButtonProps {
  label: string;
  className: string;
  icon: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

function CommentActionButton({
  label,
  className,
  icon,
  onClick,
  disabled,
}: CommentActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex flex-row w-full items-center gap-2 rounded-md px-5 py-4 ${className} ${
        disabled ? 'cursor-not-allowed' : ''
      }`}
    >
      <span className="flex items-center text-slate-50">{icon}</span>
      <span className="text-large">{label}</span>
    </button>
  );
}

